import { useParams, useNavigate } from "react-router-dom";
import { useContext } from "react";
import { PageTitle } from "../../components/PageTitle";
import { GenericChat } from "../../components/shared/chat";
import { createAdapter } from "../../components/shared/chat";
import { MainContainer } from "../../components/shared/chat";
import { useSmartSessionLoader } from "../../components/shared/chat";
import { AuthContext } from "../../context/AuthContext";
import { AiPreview } from "../aiPreview/AiPreview";

export const Rentensteuerberater = () => {
    const { sessionId } = useParams<{ sessionId: string }>();
    const navigate = useNavigate();
    const adapter = createAdapter('rentensteuerberater');

    // Get subscription status
    const { canAccess } = useContext(AuthContext);
    const hasActiveSubscription = canAccess('rentensteuerberater');

    // Smart session loading - resolves to sessionId or loading state
    const { resolvedSessionId, isLoading } = useSmartSessionLoader('job_tax', sessionId || null);

    const handleSessionChange = (newSessionId: string) => {
        if (!newSessionId) {
            console.warn('handleSessionChange called with empty sessionId');
            return;
        }
        navigate(`/rentensteuerberater/${newSessionId}`, { replace: true });
    };

    const handleNewSession = () => {
        navigate('/rentensteuerberater', { replace: true });
    };

    // Show loading state when resolving which session to use
    if (isLoading) {
        return (
            <div>
                <PageTitle title="Steuer & Rente Experte" />
                <MainContainer>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '50vh',
                        flexDirection: 'column',
                        gap: '16px'
                    }}>
                        <div style={{ fontSize: '16px', color: '#666' }}>
                            Lade letzte Steuer & Rente Experte-Sitzung...
                        </div>
                    </div>
                </MainContainer>
            </div>
        );
    }

    return (
        <div>
            <PageTitle title="Steuer & Rente Experte" />
            <div>
                <MainContainer>
                    <div style={{ position: 'relative', height: '100%' }}>
                        {!hasActiveSubscription && (
                            <div style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                zIndex: 99,
                            }}>
                                    <AiPreview />
                            </div>
                        )}
                        <GenericChat
                            adapter={adapter}
                            hasActiveSubscription={hasActiveSubscription}
                            useTextArea={true}
                            placeholder="Stellen Sie Ihre Fragen zu Rentensteuern..."
                            loadingText="Steuer & Rente Experte schreibt..."
                            loginPrompt="Bitte melden Sie sich an, um Ihre Steuer & Rente Experte-Sitzung zu starten."
                            showSidebar={true}
                            onSessionChange={handleSessionChange}
                            initialSessionId={resolvedSessionId}
                            onNewSession={handleNewSession}
                            conversationType="job_tax"
                        />
                    </div>
                </MainContainer>
            </div>
        </div>
    );
};
